<template>
  <div class="app-container">
    <el-form
      ref="form"
      :model="listQuery"
      label-position="left"
      label-width="350px"
      style="width: 90%; margin-left:50px;"
    >
      <el-form-item label="是否包含手机号码和姓名">
        <el-switch
          v-model="listQuery.hasNamePhone"
          active-color="#13ce66"
          inactive-color="#CCCCCC"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否包含地址">
        <el-switch
          v-model="listQuery.hasAddress"
          active-color="#13ce66"
          inactive-color="#CCCCCC"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否包含安全码">
        <el-switch
          v-model="listQuery.hasCvv"
          active-color="#13ce66"
          inactive-color="#CCCCCC"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="时间区间">
        <div class="block">
          <el-date-picker
            v-model="listQuery.time"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="handleExport" :loading="btnLoading"
          >导出</el-button
        >
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer"></div>
  </div>
</template>

<script>
import { exportUsersCard } from "@/api/user";
import { formatApiDate } from "@/utils/utils";
import { getValue } from "@/utils/enumUtile";
import moment from "moment/moment";
import { uploadXlsx } from "@/utils";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      listQuery: {
        time: [],
        startTime: "",
        endTime: "",
        hasNamePhone: "",
        hasAddress: "",
        hasCvv: ""
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value2: "",
      btnLoading: false
    };
  },
  created() {},
  watch: {},
  methods: {
    getValue,
    /**
     * 导出
     */
    handleExport() {
      // this.btnLoading = true;
      const listQuery = this.listQuery;
      const params = {
        ...listQuery
      };
      if (listQuery.time && listQuery.time.length > 0) {
        params.startTime = moment(
          moment(listQuery.time[0]).format("YYYY-MM-DD") + " 00:00:00"
        ).valueOf();
        params.endTime = moment(
          moment(listQuery.time[1]).format("YYYY-MM-DD") + " 23:59:59"
        ).valueOf();
      }
      delete params.time;
      console.log("params", params);
      exportUsersCard(params).then(response => {
        uploadXlsx(response, "用户卡表");
      });
    }
  }
};
</script>
<style scoped lang="scss">
.box-card {
  margin-bottom: 10px;
}
.filter-item {
  margin-left: 10px;
}
</style>
